import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import ProtectedRoute from "./auth/ProtectedRoute";
import PublicBlockRoute from "./auth/PublicBlockRoute";

import AdminLayout from "./layouts/admin/AdminLayout";
import StudentLayout from "./layouts/student/StudentLayout";
import CoachLayout from "./layouts/coach/CoachLayout";
import PublicLayout from "./layouts/PublicLayout";

import adminRoutes from "./routes/adminRoutes";
import studentRoutes from "./routes/studentRoutes";
import coachRoutes from "./routes/coachRoutes";
import publicRoutes from "./routes/publicRoutes";

import queryClient from "./lib/queryClient";

/* =========================================
   ROLE CONFIGURATION (CENTRALIZED)
========================================= */

const ROLE_CONFIG = {
  ADMIN: ["Super Admin", "State Admin", "City Admin", "Unit Admin"],
  COACH: ["Coach", "Coordinator"],
  STUDENT: ["Student"],
  PUBLIC: ["Public User"],
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>

          {/* 🌍 PUBLIC ROUTES */}
          {/* 🌍 PUBLIC ROUTES */}
  <Route element={
    <PublicBlockRoute>
      <PublicLayout />
    </PublicBlockRoute>
  }>
            {publicRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  route.requireAuth ? (
                    <ProtectedRoute allowedRoles={ROLE_CONFIG.PUBLIC}>
                      {route.element}
                    </ProtectedRoute>
                  ) : (
                    route.element
                  )
                }
              />
            ))}
          </Route>

          {/* 🔴 ADMIN ROUTES */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute allowedRoles={ROLE_CONFIG.ADMIN}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            {adminRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Route>

          {/* 🟢 COACH ROUTES */}
          <Route
            path="/coach/*"
            element={
              <ProtectedRoute allowedRoles={ROLE_CONFIG.COACH}>
                <CoachLayout />
              </ProtectedRoute>
            }
          >
            {coachRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Route>

          {/* 🟡 STUDENT ROUTES */}
          <Route
            path="/student/*"
            element={
              <ProtectedRoute allowedRoles={ROLE_CONFIG.STUDENT}>
                <StudentLayout />
              </ProtectedRoute>
            }
          >
            {studentRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Route>

        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
